function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  viewBox: "0 0 512 512"
}, props), React.createElement("path", {
  d: "M484 48c15 0 28 13 28 28v359c0 15-13 28-28 28H28c-15 0-28-13-28-28V76c0-15 13-28 28-28zM64 400h384V240H64zm0-224h384v-64H64z"
})));